'use strict';

export default function() {
	$('#js-open-forgot-password').magnificPopup({
		focus: '#l-Customer_LoginEmail',
		items: {
			src: $('#js-forgot-password'),
			type: 'inline'
		}
	});
}
